import { render, staticRenderFns } from "./PC_goodList.vue?vue&type=template&id=f2f77cb4&scoped=true&"
import script from "./PC_goodList.vue?vue&type=script&lang=js&"
export * from "./PC_goodList.vue?vue&type=script&lang=js&"
import style0 from "./PC_goodList.vue?vue&type=style&index=0&id=f2f77cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f77cb4",
  null
  
)

export default component.exports